import type { ChartData } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

import { CenterFlex, Flex } from '@/components/base';
import Heading from '@/components/Typography/Heading';
import { MainText } from '@/components/Typography/NamedTypo';

type Props = {
  dataLength: number;
  chartData: ChartData<'doughnut'>;
  total: number;
  label: string;
};

const DistributionChart = (props: Props) => {
  const chartOptions = {
    cutout: 75,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      },
    },
  };

  return (
    <Flex f={1} style={{ height: 250, position: 'relative' }}>
      {props.dataLength === 0 ? (
        <CenterFlex style={{ height: 250, width: '100%' }}>
          <MainText dim>No data</MainText>
        </CenterFlex>
      ) : (
        <CenterFlex f={1}>
          <Doughnut
            data={props.chartData}
            options={chartOptions}
            style={{ position: 'relative', zIndex: 1 }}
          />
          <CenterFlex
            d="column"
            g={8}
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              zIndex: 0,
            }}
          >
            <Heading type="h3">{props.total}</Heading>
            <MainText dim>{props.label}</MainText>
          </CenterFlex>
        </CenterFlex>
      )}
    </Flex>
  );
};

export default DistributionChart;
